import { Provider } from '@angular/core';
import { MeasurementApiService, provideMeasurementApiOrigin } from '@isaia/measurement';
import { MeasurementService } from './measurement.service';
import { MeasurementRepository } from './measurement.repository';

export function provideMeasurement(options: { origin: string }): Provider {
  return [provideMeasurementApiOrigin(options.origin), MeasurementService, MeasurementApiService, MeasurementRepository];
}
